import { getProxyUrl } from '.'
import { OpenProjectResponse } from '@types'

export async function openProyect(id: number, tmp = false): Promise<OpenProjectResponse | undefined> {
  let url
  if (tmp) {
    url = getProxyUrl('api/Diseno/abrirdisenyotmp/')
  } else {
    url = getProxyUrl('api/Diseno/abrirdisenyo/')
  }
  const params = {
    id,
    method: 'GET',
    mode: 'cors',
    headers: {
      'Accept-Language': 'ES',
      'Content-Type': 'application/json',
      Authorization: 'Ninpo ' + sessionStorage.getItem('access_token'),
    },
  }

  try {
    const data = await fetch(url + id, params as RequestInit)
    if (data.status === 200) {
      const json = await data.json()
      return json as OpenProjectResponse
    } else {
      return
    }
  } catch (e: any) {}
}
